var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 121",
    className: "w-[120px] h-[120px] shrink-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fast_svg__a)",
    d: "M63.66 13.218c22.251 7.935 37.792 62.865 26.67 79.987-11.122 17.122-70.502-.364-80.767-14.935C-.702 63.7 41.409 5.28 63.659 13.218Z",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fast_svg__b)",
    d: "M39.072 23.236C59.619 18.349 98.02 51.962 98.02 70.214c0 18.253-53.033 34.061-67.825 28.137-14.791-5.924-11.67-70.227 8.877-75.115Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.117 59.09a1.666 1.666 0 0 0-1.45-1h-7.634l2.117-7.9a1.668 1.668 0 0 0-.283-1.45 1.668 1.668 0 0 0-1.317-.65H48.884a1.667 1.667 0 0 0-1.667 1.233L42.75 65.989a1.667 1.667 0 0 0 .283 1.45 1.667 1.667 0 0 0 1.334.65h6.45L47.8 79.323a1.667 1.667 0 0 0 2.85 1.55l18.167-20a1.667 1.667 0 0 0 .3-1.784ZM52.8 73.555l1.784-6.667a1.666 1.666 0 0 0-.284-1.45 1.666 1.666 0 0 0-1.316-.65h-6.4l3.566-13.366h8.217l-2.117 7.9a1.666 1.666 0 0 0 1.667 2.1h5.95L52.8 73.556Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fast_svg__a",
    x1: 83.124,
    x2: 36.29,
    y1: 25.221,
    y2: 97.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8B933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29C11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fast_svg__b",
    x1: 59.51,
    x2: 59.51,
    y1: 99.616,
    y2: -7.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E65C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.930cf5f6c0690bd563318c26d7c21fb3.svg";
export { ForwardRef as ReactComponent };